import React from "react"
import Emoji from "react-emoji-render"
//import Octicon, { MarkGithub } from "@primer/octicons-react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: {
        Content: () => (
            <>
                <p>
                    Contact us with any questions
                </p>
                <p>
                    <Emoji text="Made with ❤️  by Brian and Lin." />
                </p>
            </>
        ),
    },
    [LANGUAGE.ZH]: {
        Content: () => (
            <>
                <p>
                   如果有任何问题，请随时联系我们哦
                </p>
                <p>
                    <Emoji text="布莱恩和毛琳用心呈现❤️ ." />
                </p>
            </>
        ),
    },
}
